module.exports = __webpack_public_path__ + "static/media/skinnySelfcare1.fd943b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/skinnySelfcare1.png
// module id = 1234
// module chunks = 0